<template>
  <div style="padding-top:35vh" v-if="isAuthenticating">
    <img alt=" " src="@/assets/main.gif" width="100px" style="display:block;margin:0 auto">
    <p align="center">Facebook Authentication, Please wait...</p>
  </div>
</template>

<script>
export default {
  name: 'FBAuthentication',
  computed: {
    isAuthenticating: {
      get () { return this.$store.state.base.isFBAuthenticating }
    }
  },
  mounted () {
    this.code = ('code' in this.$route.query && this.$route.query.code) ? this.$route.query.code : null
    if (this.code) {
      this.$store.dispatch('base/fbAuthenticate', {code: this.code})
    } else {
      this.$router.replace({path: '/home'})
    }
  }
}
</script>
